import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { PROCESS_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const ProcessApi = createApi({
  reducerPath: "Process",
  baseQuery,
  tagTypes: ["Process"],
  endpoints: (builder) => ({
    getProcess: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: PROCESS_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: PROCESS_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["Process"],
    }),
    getProcessById: builder.query({
      query: (id) => {
        return {
          url: `${PROCESS_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["Process"],
    }),
    addProcess: builder.mutation({
      query: (payload) => ({
        url: PROCESS_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["Process"],
    }),
    updateProcess: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${PROCESS_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Process"],
    }),
    deleteProcess: builder.mutation({
      query: (id) => ({
        url: `${PROCESS_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Process"],
    }),
  }),
});

export const {
  useGetProcessQuery,
  useGetProcessByIdQuery,
  useAddProcessMutation,
  useUpdateProcessMutation,
  useDeleteProcessMutation,
} = ProcessApi;

export default ProcessApi;
